import { LoaderComponent } from "./../component/loader/loader.component";
import { PaginationComponent } from "./../component/pagination/pagination.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TextAreaComponent } from "@app/shared/component/text-area/text-area.component";
import { StarRatingComponent } from "@app/shared/component/star-rating/star-rating.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ExportCsvPdfComponent } from "@app/shared/component/export-csv-pdf/export-csv-pdf.component";
import { ExportCsvPdf1Component } from "@app/shared/component/export-csv-pdf/export-csv-pdf1.component";
import { NoDataComponent } from "@app/shared/component/no-data/no-data.component";
import {
  MyDatePipe,
  MyDateTimePipe
} from "@app/shared/services/date-formatter.service";
import { BarChartComponent } from "@app/shared/component/bar-chart/bar-chart.component";
import { MorrisJsModule } from "angular-morris-js";
import { DonutChartComponent } from "@app/shared/component/donut-chart/donut-chart.component";
import { DataLoaderComponent } from "@app/shared/component/loader/data.loader.component";
import { UtilityFunctionService } from "@app/shared/services/utility-function.service";
import { DateComparer } from "@app/shared/services/date-comparer.service";
import { OnRouteService } from "@app/shared/services/onroute.services";
import { RideFareTooltipComponent } from "@app/shared/component/ride-fare-tooltip/ride-fare-tooltip.component";
import { SixEarningTooltipComponent } from "@app/shared/component/six-earning-tooltip/six-earning-tooltip.component";
import { TollTaxTooltipComponent } from "@app/shared/component/toll-tax-tooltip/toll-tax-tooltip.component";
import { MalihuCustomScrollerModule } from "ngx-malihu-scroller";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    MorrisJsModule,
    MalihuCustomScrollerModule
  ],
  declarations: [
    PaginationComponent,
    LoaderComponent,
    TextAreaComponent,
    StarRatingComponent,
    ExportCsvPdfComponent,
    ExportCsvPdf1Component,
    NoDataComponent,
    MyDatePipe,
    MyDateTimePipe,
    BarChartComponent,
    DonutChartComponent,
    DataLoaderComponent,
    SixEarningTooltipComponent,
    RideFareTooltipComponent,
    TollTaxTooltipComponent
  ],
  exports: [
    PaginationComponent,
    LoaderComponent,
    TextAreaComponent,
    StarRatingComponent,
    ExportCsvPdfComponent,
    ExportCsvPdf1Component,
    NoDataComponent,
    MyDatePipe,
    MyDateTimePipe,
    BarChartComponent,
    DonutChartComponent,
    DataLoaderComponent,
    SixEarningTooltipComponent,
    RideFareTooltipComponent,
    TollTaxTooltipComponent,
    MalihuCustomScrollerModule
  ],
  providers: [UtilityFunctionService, DateComparer, OnRouteService]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/module/shared.module.ts